import { AutoCompleteModule } from '../shared/autoComplete/autoComplete.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { AppMaterialModule } from '../shared/appMaterial/app-material.module';
import { PublicComponent } from './public.component';
import { PublicRoutingModule } from './public-routing.module';
import { SignUpModule } from '../sign-up/sign-up.module';
import { LoginModule } from '../login/login.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { ChickenTestComponent } from './chicken-test/chicken-test.component';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { AllForHireModule } from './all-for-hire/all-for-hire.module';
import { ForHireModule } from './all-for-hire/for-hire/for-hire.module';
import { SearchModule } from '../shared/public-components/search/search.module';
import { ExploreModule } from '../shared/public-components/explore/explore.module';
import { MobileTosModule } from './mobile-tos/mobile-tos.module';
import { MobilePrivacyModule } from './mobile-privacy/mobile-privacy.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { CreateCrewMemberComponent } from './create-crew-member/create-crew-member.component';
import { MarkCharterCompleteComponent } from './mark-charter-complete/mark-charter-complete.component';
import { PublishPaymentsComponent } from './publish-payments/publish-payments.component';
import { PaypalExplanationDialogComponent } from './paypal-explanation/paypal-explanation.component';
import { ListMyBoatModule } from './list-my-boat/list-my-boat.module';
import { CharterBuyflowVesselDetailModule } from './charter-buyflow/charter-buyflow-vessel-detail/charter-buyflow-vessel-detail.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { BuyflowVesselListModule } from '../shared/public-components/buyflow-vessel-list/buyflow-vessel-list.module';
import { MainPipe } from '../shared/pipes/pipes.module';
import { CharterPriceDetailDialogComponent } from './charter-price-detail/charter-price-detail-dialog.component';
import { AddNewCostDialogComponent } from '../portal/charters/manage-charter/add-new-cost/add-new-cost-dialog.component';
import { ChangePayoutPayeeDialogComponent } from './change-payout-payee-dialog/change-payout-payee-dialog.component';
import { VesselImageDeleteDialogComponent } from './vessel-image-delete-dialog/vessel-image-delete-dialog.component';
import { ImageCropperDialogComponent } from './image-cropper-dialog/image-cropper-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { LoadingModule } from '../shared/loading/loading.module';
import { CancellationPolicyModule } from './cancellation-policy/cancellation-policy.module';
import { CustomerModule } from '../customer/customer.module';
import { DisplayWaterbodyTileModule } from '../portal/admin/water-bodies/display/display-waterbody-tile/display-waterbody-tile.module';
import { CookiesStatementModule } from './cookie-statement/cookies-statement.module';
import { IndependentContractorAgreementModule } from './independent-contractor-agreement/independent-contractor-agreement.module';
import { ViewImagesDialogComponent } from './view-images/view-images-dialog.component';
import { BecomeACaptainLandingModule } from './become-a-captain-landing/become-a-captain-landing.module';
import { BuyflowSearchBarModule } from './buyflow-search-bar/buyflow-search-bar.module';

@NgModule({
  imports: [
    CommonModule,
    PublicRoutingModule,
    AppMaterialModule,
    FlexLayoutModule,
    SharedModule,
    SignUpModule,
    LoginModule,
    AutoCompleteModule,
    ForHireModule,
    AllForHireModule,
    SearchModule,
    ExploreModule,
    MobileTosModule,
    CancellationPolicyModule,
    MobilePrivacyModule,
    ReactiveFormsModule,
    TextMaskModule,
    ListMyBoatModule,
    CharterBuyflowVesselDetailModule,
    MatDatepickerModule,
    MatInputModule,
    BuyflowVesselListModule,
    MainPipe,
    MatRadioModule,
    ImageCropperModule,
    LoadingModule,
    CustomerModule,
    DisplayWaterbodyTileModule,
    CookiesStatementModule,
    IndependentContractorAgreementModule,
    BuyflowSearchBarModule,
  ],
  declarations: [
    PublicComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    DeleteDialogComponent,
    VesselImageDeleteDialogComponent,
    ImageCropperDialogComponent,
    ChickenTestComponent,
    VideoDialogComponent,
    CreateCrewMemberComponent,
    MarkCharterCompleteComponent,
    PublishPaymentsComponent,
    PaypalExplanationDialogComponent,
    CharterPriceDetailDialogComponent,
    AddNewCostDialogComponent,
    ChangePayoutPayeeDialogComponent,
    ViewImagesDialogComponent,
  ],
  exports: [
    PublicComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    DeleteDialogComponent,
    VesselImageDeleteDialogComponent,
    ImageCropperDialogComponent,
    ChickenTestComponent,
    VideoDialogComponent,
    CreateCrewMemberComponent,
    MarkCharterCompleteComponent,
    PublishPaymentsComponent,
    PaypalExplanationDialogComponent,
    CharterPriceDetailDialogComponent,
    AddNewCostDialogComponent,
    ChangePayoutPayeeDialogComponent,
    ViewImagesDialogComponent,
    BecomeACaptainLandingModule,
  ],
  entryComponents: [
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    DeleteDialogComponent,
    VesselImageDeleteDialogComponent,
    ImageCropperDialogComponent,
    ChickenTestComponent,
    VideoDialogComponent,
    CreateCrewMemberComponent,
    MarkCharterCompleteComponent,
    PublishPaymentsComponent,
    PaypalExplanationDialogComponent,
    CharterPriceDetailDialogComponent,
    AddNewCostDialogComponent,
    ChangePayoutPayeeDialogComponent,
    ViewImagesDialogComponent,
  ],

  providers: [],
})
export class PublicModule {}
